import { connect } from 'react-redux';

import { actionUpdateLocation } from 'store/location/room/actions';

import ModalEditPriceRoom from './ModalEditPriceRoom';

const mapStateToProps = (state) => ({
  loadingUpdateRoomStatusList: state.RoomStatusList.loadingUpdateRoomStatusList,
});

const mapDispatchToProps = (dispatch) => ({
  actionUpdateLocation: (payload) => dispatch(actionUpdateLocation(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditPriceRoom);
